export class LegalNoticeMessages {
  public addresse = 'legal-notice.addresse';
  public aife = 'legal-notice.aife';
  public copy = 'legal-notice.copy';
  public creation = 'legal-notice.creation';
  public design = 'legal-notice.design';
  public director = 'legal-notice.director';
  public directorPub = 'legal-notice.director_pub';
  public editorial = 'legal-notice.editorial';
  public join = 'legal-notice.join';
  public legalNotices = 'legal-notice.legal-notice';
  public link = 'legal-notice.link';
  public minefi = 'legal-notice.minefi';
  public open = 'legal-notice.open';
  public portal = 'legal-notice.portal';
  public repRights = 'legal-notice.rep_rights';
  public rho = 'legal-notice.rho';
  public site = 'legal-notice.site';
  public street = 'legal-notice.street';
  public url = 'legal-notice.url';
  public zipCode = 'legal-notice.zip_code';
  constructor() {
  }
}
